import type { UseFormReturnType } from '@mantine/form';
import { createContext, type Dispatch, type SetStateAction } from 'react';
import type { ZodObject } from 'zod/v4';

export type FormRegister = {
  // biome-ignore lint/suspicious/noExplicitAny: registry stores heterogeneous form shapes; UseFormReturnType is invariant in its values type, so a bounded generic would reject every concrete form.
  form: UseFormReturnType<any>;
  schema: ZodObject;
};

export type FormsRegister = Record<string, FormRegister>;

export interface FormsRegisterContextType {
  formsRegister: FormsRegister;
  setFormsRegister: Dispatch<SetStateAction<FormsRegister>>;
}

export const FormsRegisterContext = createContext<
  FormsRegisterContextType | undefined
>(undefined);
